import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React from "react";

function escapeHtml(value) {
  return (value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function sanitizeMailHtml(html) {
  return (html || "")
    .replace(/<img[^>]+src=["']cid:[^"']*["'][^>]*>/gi, "")
    .replace(/<source[^>]+src=["']cid:[^"']*["'][^>]*>/gi, "")
    .replace(/<a([^>]+)href=["']cid:[^"']*["']([^>]*)>/gi, "<span$1$2>")
    .replace(/<\/a>/gi, "</span>");
}

function formatFileSize(sizeBytes) {
  if (!sizeBytes && sizeBytes !== 0) return "";
  if (sizeBytes < 1024) return `${sizeBytes} B`;
  if (sizeBytes < 1024 * 1024) return `${(sizeBytes / 1024).toFixed(1)} KB`;
  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function MailViewDialog({
  open,
  onClose,
  mail,
  onDownloadAttachment,
  downloadingAttachmentKey,
}) {
  const htmlBody = mail?.cuerpo_html || "";
  const textBody = mail?.cuerpo_texto || "";
  const renderedBody = htmlBody
    ? sanitizeMailHtml(htmlBody)
    : textBody
    ? `<div>${escapeHtml(textBody).replace(/\r?\n/g, "<br/>")}</div>`
    : "";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Ver mail</DialogTitle>
      <DialogContent>
        <div className="row">
          <div className="col-md-6">
            <TextField
              fullWidth
              margin="normal"
              variant="outlined"
              label="ID"
              value={mail?.id || ""}
              InputLabelProps={{ shrink: true }}
              InputProps={{ readOnly: true }}
            />
          </div>
          <div className="col-md-6">
            <TextField
              fullWidth
              margin="normal"
              variant="outlined"
              label="Tipo"
              value={mail?.tipo_mail || ""}
              InputLabelProps={{ shrink: true }}
              InputProps={{ readOnly: true }}
            />
          </div>
          <div className="col-md-6">
            <TextField
              fullWidth
              margin="normal"
              variant="outlined"
              label="Remitente"
              value={mail?.remitente || ""}
              InputLabelProps={{ shrink: true }}
              InputProps={{ readOnly: true }}
            />
          </div>
          <div className="col-md-6">
            <TextField
              fullWidth
              margin="normal"
              variant="outlined"
              label="Destinatarios"
              value={mail?.destinatarios || ""}
              InputLabelProps={{ shrink: true }}
              InputProps={{ readOnly: true }}
            />
          </div>
          <div className="col-md-12">
            <TextField
              fullWidth
              margin="normal"
              variant="outlined"
              label="Asunto"
              value={mail?.asunto || ""}
              InputLabelProps={{ shrink: true }}
              InputProps={{ readOnly: true }}
            />
          </div>

          {!!mail?.adjuntos?.length && (
            <div className="col-md-12" style={{ marginTop: "12px" }}>
              <div
                style={{
                  marginBottom: "8px",
                  fontSize: "0.9rem",
                  color: "#7E8299",
                  fontWeight: 500,
                }}
              >
                Adjuntos
              </div>
              <div
                style={{
                  border: "1px solid #E4E6EF",
                  borderRadius: "0.42rem",
                  backgroundColor: "#FFFFFF",
                  overflow: "hidden",
                }}
              >
                {mail.adjuntos.map((attachment) => {
                  const downloadKey = `${mail.id}-${attachment.index}`;

                  return (
                    <div
                      key={downloadKey}
                      className="d-flex align-items-center justify-content-between px-4 py-3"
                      style={{ borderTop: "1px solid #F3F6F9" }}
                    >
                      <div style={{ minWidth: 0, paddingRight: "16px" }}>
                        <div style={{ fontWeight: 600, color: "#181C32" }}>
                          {attachment.file_name}
                        </div>
                        <div style={{ color: "#7E8299", fontSize: "0.85rem" }}>
                          {attachment.content_type}
                          {attachment.size_bytes || attachment.size_bytes === 0
                            ? ` · ${formatFileSize(attachment.size_bytes)}`
                            : ""}
                          {attachment.es_inline ? " · Inline" : ""}
                        </div>
                      </div>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => onDownloadAttachment?.(mail.id, attachment)}
                        disabled={downloadingAttachmentKey === downloadKey}
                      >
                        {downloadingAttachmentKey === downloadKey
                          ? "Descargando..."
                          : "Descargar"}
                      </Button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className="col-md-12" style={{ marginTop: "12px" }}>
            <div
              style={{
                marginBottom: "8px",
                fontSize: "0.9rem",
                color: "#7E8299",
                fontWeight: 500,
              }}
            >
              Cuerpo
            </div>
            {renderedBody ? (
              <div
                style={{
                  minHeight: "280px",
                  border: "1px solid #E4E6EF",
                  borderRadius: "0.42rem",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                }}
                dangerouslySetInnerHTML={{ __html: renderedBody }}
              />
            ) : (
              <TextField
                fullWidth
                margin="normal"
                variant="outlined"
                label="Cuerpo"
                value={textBody}
                InputLabelProps={{ shrink: true }}
                InputProps={{ readOnly: true }}
                multiline
                rows={14}
              />
            )}
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
